import { UserData } from '../../redux/slices'
import { handleClientError, post, get, remove } from '../lib'

export interface SessionResponse {
  name: string
  roles: Array<'ROLE_ADMIN' | 'ROLE_USER'>
  access_token: string
  refresh_token: string
  expires_in: number
  expires_at: number
}
export interface LoginBody {
  username: string
  password: string
}

export const postLogin = async (
  UserData: UserData
): Promise<SessionResponse> => {
  return post<LoginBody, SessionResponse>({
    path: '/auth/authorization/login',
    body: UserData
  })
}

export const handleReturnAuth = async (): Promise<SessionResponse> => {
  return get<SessionResponse>({
    path: '/auth/authorization/token'
  })
}

export const deleteSession = async (): Promise<boolean> => {
  const req = await remove({
    path: '/auth/session',
    id: '', // why is the delete function like this?
    options: {}
  })
  return req == '' ? true : false
}

export const refreshToken = async (token: string): Promise<SessionResponse> => {
  return post<{ refresh_token: string }, SessionResponse>({
    path: `/auth/authorization/refresh`,
    token,
    body: {
      refresh_token: token
    }
  })
}

export const logOut = async (): Promise<boolean> => {
  const rtn = await remove({
    path: '/auth/session',
    id: ''
  })
  return rtn === ''
}
